import { Link, useParams } from "react-router-dom";
import { getCollection } from "@/api/endpoints";
import { MediaCard } from "@/components/MediaCard";
import { useApi } from "@/hooks/useApi";
import { collectionArtworkSrc } from "@/pages/CollectionsPage";

export function CollectionPage() {
  const { collectionId } = useParams<{ collectionId: string }>();
  const collection = useApi(() => getCollection(collectionId!), [collectionId]);

  if (collection.loading) return <div className="page-loading">Loading...</div>;
  if (collection.error) return <p className="error-message">Collection not found</p>;
  if (!collection.data) return null;

  const resource = collection.data.data;
  const attrs = resource.attributes;
  const members = resource.relationships.items?.data ?? [];
  const backdropSrc = collectionArtworkSrc(attrs.backdrop_path, "w1280");
  const posterSrc = collectionArtworkSrc(attrs.poster_path, "w342");

  return (
    <div className="collection-detail-page">
      <div className="collection-detail-hero">
        {backdropSrc ? (
          <img className="collection-detail-backdrop" src={backdropSrc} alt="" />
        ) : (
          <div className="collection-detail-backdrop collection-detail-backdrop--placeholder" aria-hidden="true" />
        )}
        <div className="collection-detail-gradient" />
      </div>

      <div className="collection-detail-header">
        {posterSrc ? (
          <img className="collection-detail-poster" src={posterSrc} alt={attrs.name} />
        ) : (
          <div className="collection-detail-poster collection-detail-poster--placeholder" aria-hidden="true">
            {attrs.name.slice(0, 2).toUpperCase()}
          </div>
        )}

        <div className="collection-detail-copy">
          <Link className="item-kicker item-kicker--link" to="/collections">
            Collections
          </Link>
          <h1 className="item-title">{attrs.name}</h1>
          <div className="item-meta-row">
            <span className="item-meta-item">
              {attrs.item_count.toLocaleString()} movie{attrs.item_count === 1 ? "" : "s"}
            </span>
            <span className="badge">collection</span>
          </div>
          {attrs.overview && <p className="item-overview">{attrs.overview}</p>}
        </div>
      </div>

      <section className="collection-members-section">
        <div className="item-section-heading">
          <div>
            <h2 className="item-section-title">Movies</h2>
            <p className="item-section-subtitle">
              {members.length > 0
                ? `${members.length} title${members.length === 1 ? "" : "s"} in library`
                : "Movies appear here after the library scan links them to this collection."}
            </p>
          </div>
        </div>

        {members.length > 0 ? (
          <div className="item-grid">
            {members.map((item) => (
              <MediaCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="library-empty-state">No member movies are visible in this library.</div>
        )}
      </section>
    </div>
  );
}
